import { Component } from '@angular/core';
import { Button } from 'primeng/button';
import { Location } from '@angular/common';

@Component({
  selector: 'app-back-button'
  , template: `
    <button
      icon="pi pi-chevron-left"
      type="button"
      class="ui-button-secondary"
      pButton
      (click)="navigateBack()"
      label="Back">
    </button>
  `
})

export class BackButtonComponent {
  constructor(private _location: Location) { }

  navigateBack() {
    this._location.back();
  }
}
